import { render, staticRenderFns } from "./ElasticProductMatrix.vue?vue&type=template&id=08b6b497&"
import script from "./ElasticProductMatrix.vue?vue&type=script&lang=js&"
export * from "./ElasticProductMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports